import "./style.less";
export default function AccordianArrow() {
    return {
        transclude: true,
        restrict: "E",
        scope: {
            obj: "=",
        },
        template: require("./template.html"),

        controller: function ($scope) {
            $scope.toggleObj = () => {
                $scope.obj._isOpen = !$scope.obj._isOpen;
            };
        },
    };
}
